<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['pdf-viewer']['width']" [height]="class['pdf-viewer']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" >
      <!-- CHỈNH SỬA NỘI DUNG -->
      <li nz-submenu [nzTitle]="'chinh_sua_noi_dung'| translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="config-font">
          <p class="title">Upload file PDF</p>
          <label for="uploadFile" class="upload-label">Upload file</label>
          <input id="uploadFile" hidden type="file" (change)="onFileSelected($event)" accept="application/pdf">
          <p>
            {{
              data_object.nameFile || (pdfTitle + '.pdf')
            }}
          </p>
        </div>
      </li>
      <!-- NHÃN -->
      <li nz-submenu [nzTitle]="'nhan'| translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
          <mat-label>{{'nhan' | translate}}<span style="color: red">*</span></mat-label>
          <textarea matInput
            [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode] || 'Trình xem tài liệu PDF: '"
            (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent('aria_label', true);"></textarea>
        </mat-form-field>
        <p class="aria-label-preview">
          aria-label="{{(staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode] || 'Trình xem tài liệu PDF: ') + pdfTitle}}"
        </p>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu [nzTitle]="'hien_thi'| translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>


</div>